import { Buffer } from 'buffer'
import { createApp } from 'vue'
import { createPinia } from 'pinia'

// Polyfill Buffer per il browser — sostituisce webpack.ProvidePlugin (Vue CLI).
// Usato da services/utility.js (base64→Blob) e ical-generator.
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
import FloatingVue from 'floating-vue'
import Notifications from '@kyvg/vue3-notification'
import VueApexCharts from 'vue3-apexcharts'
import { registerSW } from 'virtual:pwa-register'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import filters from './plugins/filters'
import directives from './plugins/directives'
import bus from './plugins/bus'

// componenti globali (port da main.js Vue 2)
import Breadcrumb from '@/components/breadcrumb/Breadcrumb.vue'
import OverlayLoader from '@/components/loaders/OverlayLoader.vue'
import ComponentWrapperLoader from '@/components/loaders/ComponentWrapperLoader.vue'

import 'floating-vue/dist/style.css'

// Recupero chunk obsoleti dopo un deploy: un client con la vecchia index.html prova
// a importare un chunk per-rotta il cui hash non esiste più su S3 (la sync usa --delete).
// L'import dinamico fallisce → Vite emette `vite:preloadError`. Ricarichiamo una volta
// sola (guard in sessionStorage anti-loop) così il browser riscarica la index.html
// no-cache e ottiene i nuovi hash. Vedi deploy/aws/03-publish.sh.
window.addEventListener('vite:preloadError', () => {
  if (sessionStorage.getItem('vite-preload-reloaded') === '1') return
  sessionStorage.setItem('vite-preload-reloaded', '1')
  window.location.reload()
})
// reset del guard quando una navigazione va a buon fine (app caricata correttamente)
window.addEventListener('load', () => sessionStorage.removeItem('vite-preload-reloaded'))

// Auto-aggiornamento PWA. Con registerType 'autoUpdate' il nuovo service worker
// (skipWaiting + clientsClaim) si attiva e ricarica la pagina da solo appena viene
// rilevato. Ma un tab SPA resta aperto a lungo senza rinavigare → il SW non
// ricontrolla mai e il client resta su una versione vecchia. Qui forziamo il
// ricontrollo periodico e al ritorno in focus: così, dopo una pubblicazione, i
// client prendono la nuova versione da soli, senza svuotare la cache a mano.
registerSW({
  immediate: true,
  onRegisteredSW(swUrl, registration) {
    if (!registration) return
    const checkForUpdate = () => { registration.update().catch(() => {}) }
    // ricontrollo ogni 15 minuti
    setInterval(checkForUpdate, 15 * 60 * 1000)
    // e quando il tab torna visibile (ripresa dopo standby/altra scheda)
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) checkForUpdate()
    })
  },
})

// Quando il nuovo SW (skipWaiting+clientsClaim) prende il controllo della pagina,
// ricarichiamo una volta per montare il nuovo bundle. Guard anti-loop.
if ('serviceWorker' in navigator) {
  let swReloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (swReloading) return
    swReloading = true
    window.location.reload()
  })
}

const app = createApp(App)

app
  .use(createPinia())
  .use(router)
  .use(i18n)
  .use(FloatingVue) // sostituisce v-tooltip / v-popover
  .use(Notifications) // sostituisce vue-notification
  .use(filters) // $filters (ex globalFilters)
  .use(directives) // direttive globali (ex globalDirectives)

// event bus globale (ex Vue.prototype.$bus = new Vue())
app.config.globalProperties.$bus = bus

app.component('Apexchart', VueApexCharts)
app.component('Breadcrumb', Breadcrumb)
app.component('OverlayLoader', OverlayLoader)
app.component('ComponentWrapperLoader', ComponentWrapperLoader)

app.mount('#app')
